import { ReactComponent as NewsIconSVG } from "./news-icon.svg";
import { SvgIcon } from '@mui/material';

export default function IconNews(props) {
  return <SvgIcon {...props} component={NewsIconSVG} viewBox="0 0 825 769" />;
}